import { Link } from "@tanstack/react-router";
import { Fragment } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { buildBreadcrumbItems } from "@/lib/breadcrumbs";

export function BreadcrumbNav({ pathname }: { pathname: string }) {
  const items = buildBreadcrumbItems(pathname);
  if (items.length === 0) return null;

  const spanish = pathname === "/es" || pathname.startsWith("/es/");

  return (
    <div className="border-b border-border/60 bg-background">
      <Breadcrumb
        aria-label={spanish ? "Ruta de navegación" : "Breadcrumb"}
        className="mx-auto w-full max-w-7xl px-6 py-2 md:px-12 lg:px-32 xl:px-44 2xl:px-56"
      >
        <BreadcrumbList className="gap-1 text-sm sm:gap-1.5">
          {items.map((item, index) => {
            const current = index === items.length - 1;
            return (
              <Fragment key={`${item.path}-${index}`}>
                {index > 0 ? <BreadcrumbSeparator /> : null}
                <BreadcrumbItem
                  data-breadcrumb-name={item.name}
                  data-breadcrumb-url={item.url}
                  className="min-w-0 gap-1 sm:gap-1.5"
                >
                  {current ? (
                    <BreadcrumbPage className="line-clamp-1">{item.name}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link
                        to={item.path as never}
                        preload="intent"
                        activeOptions={{ exact: true }}
                      >
                        {item.name}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}